import { render, staticRenderFns } from "./ChangeTaskStatus.vue?vue&type=template&id=57adb657&"
import script from "./ChangeTaskStatus.vue?vue&type=script&lang=js&"
export * from "./ChangeTaskStatus.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports